import React from 'react';
import './Recyclable.css';

const Recyclable = () => {
  const highlights = [
    {
      title: 'Reduce, Reuse and Reprocess',
      description:
        'Our sustainability approach is built on practical circularity: reducing waste, encouraging reuse, and reprocessing material responsibly.',
      icon: 'fas fa-sync-alt'
    },
    {
      title: 'PP & BOPP Are Recyclable',
      description:
        'Our PP and BOPP woven packaging solutions are reusable and recyclable, making them a practical and environmentally conscious choice.',
      icon: 'fas fa-recycle'
    },
    {
      title: 'Lower-Temperature Recycling',
      description:
        'BOPP can be recycled at comparatively lower temperatures, helping reduce process energy requirements.',
      icon: 'fas fa-leaf'
    }
  ];

  const principles = [
    'Design for separability, labeling clarity, and practical recyclability.',
    'Enable cleaner post-use material streams for easier processing.',
    'Convert recyclable material into useful reprocessed granules.',
    'Continuously improve through technology and process innovation.'
  ];

  return (
    <section className="recyclable section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">I Am 100% Recyclable</h2>
          <p className="section-subtitle">
            Sustainable woven packaging designed for circular value
          </p>
        </div>

        <div className="recyclable-hero-card">
          <h3>Built for Responsible Packaging</h3>
          <p>
            At Maharaja Polyfab, we are committed to developing PP and BOPP packaging
            solutions that support long-term sustainability goals. Our products are
            engineered to be reused and recycled, helping businesses move toward
            cleaner packaging ecosystems.
          </p>
        </div>

        <div className="recyclable-grid">
          {highlights.map((item, index) => (
            <div key={index} className="recyclable-card">
              <div className="recyclable-icon">
                <i className={item.icon}></i>
              </div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        <div className="recyclable-principles">
          <h3>Our Recyclability Focus</h3>
          <ul>
            {principles.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>

        <div className="recyclable-note">
          <p>
            Recycled material from used PP/BOPP packaging can be processed into
            reprocessed granules for further industrial applications, supporting
            resource efficiency across the value chain.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Recyclable;
